// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from CalendarViewResultPreview.module.scss  */
.CalendarViewResultPreview-module-Root_38T {
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  padding-block: 0.8rem; }
  .CalendarViewResultPreview-module-Root_38T::after {
    position: absolute;
    top: 3.5rem;
    left: 50%;
    display: block;
    width: 80%;
    height: 1px;
    content: '';
    background-color: var(--calendar-divider);
    transform: translateX(-50%); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Calendar/View/ResultPreview/CalendarViewResultPreview.css"],"names":[],"mappings":"AAAA,0DAA0D;AAC1D;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB,EAAE;EACvB;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,cAAc;IACd,UAAU;IACV,WAAW;IACX,WAAW;IACX,yCAAyC;IACzC,2BAA2B,EAAE","sourcesContent":["/*  imported from CalendarViewResultPreview.module.scss  */\n.CalendarViewResultPreview-module-Root_38T {\n  display: flex;\n  justify-content: center;\n  box-sizing: border-box;\n  padding-block: 0.8rem; }\n  .CalendarViewResultPreview-module-Root_38T::after {\n    position: absolute;\n    top: 3.5rem;\n    left: 50%;\n    display: block;\n    width: 80%;\n    height: 1px;\n    content: '';\n    background-color: var(--calendar-divider);\n    transform: translateX(-50%); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
